import { render, staticRenderFns } from "./CasesPending.vue?vue&type=template&id=bea118e6&scoped=true&"
import script from "./CasesPending.vue?vue&type=script&lang=js&"
export * from "./CasesPending.vue?vue&type=script&lang=js&"
import style0 from "./CasesPending.vue?vue&type=style&index=0&id=bea118e6&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea118e6",
  null
  
)

export default component.exports